import React from 'react';
import {BiMath} from "react-icons/bi";


export function Algorithm({title, steps}) {

    return (
        <div className={"mb-5    d-flex flex-column"} style={{fontFamily:"Inter"}} >
            <div className={"row m-0 px-3  py-2   border-dark d-flex align-items-center d-none "} style={{backgroundColor:"#2F80ED"}}>
                <h4 className={"col text-white d-flex align-items-center m-0 p-0 py-2"}>{title}</h4>
                <div className={"text-white col-2 text-end d-flex align-items-center justify-content-end"}>
                    <BiMath size={36} className={"m-0 p-0"}/>
                </div>

            </div>
            {steps}
        </div>
    );

}